{
    "sessionWarningFirstPhrase": "Your session is about to expire in",
    "sessionWarningSecondPhrase": "Are you still there?",
    "sessionLogout": "Your session has expired. Please login again.",
    "authorizationError": "Please contact the ATB Administrator to ensure your ATB user has the proper roles assigned. You will be automatically logged out in",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "milliseconds": "Milliseconds",
    "totalDays": "TotalDays",
    "totalHours": "TotalHours",
    "totalMinutes": "TotalMinutes",
    "totalSeconds": "TotalSeconds",
    "totalMilliseconds": "TotalMilliseconds",
    "yes": "Yes"
}